import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../reducers';

export const selectBulk = createSelector(
  (state: RootState) => state,
  (state) => state.bulk
);
